import {Forum} from '@material-ui/icons'
import ChatUserList from './chatUserList'

export default {
  name: 'chat_bot_plugin/chatuser',
  icon: Forum,
  list: ChatUserList,
};
